/* T48-SIMGYM v1 + T49-SIMGYM v2.3 (2026-06-08)
   CRITICAL v2.3: NIE wstawiamy do .product-card__media (flickity carousel).
   Injection do CARD ROOT only. MutationObserver wyłączony dla .product-card subtree.

   T61 (2026-08-11) — DZIURA 2: quick view pobiera /products/<handle>.js i wstawial
   cene KAZDEGO produktu, takze Pro (tag B2B / Professional). Cena szla tez do
   dataLayer (quick_view_open, quick_view_add_to_cart), czyli do GTM/GA4/pikseli.
   Bramka po stronie klienta: tagi produktu + globalna flaga window.__CC_B2B
   (layout/theme.liquid, z customer.b2b?). Zablokowany produkt: tekst
   „Cena po weryfikacji", brak ceny za ml, ukryty i wylaczony przycisk koszyka,
   klucz `price` usuniety z obu pushy dataLayer. Tag pro_approved NIE nadaje nic (T60).
*/
(function(){
  'use strict';

  function $(sel,root){return (root||document).querySelector(sel);}
  function $$(sel,root){return Array.prototype.slice.call((root||document).querySelectorAll(sel));}
  function on(el,ev,fn,opts){if(el)el.addEventListener(ev,fn,opts||false);}
  function fireDL(ev,data){try{window.dataLayer=window.dataLayer||[];window.dataLayer.push(Object.assign({event:ev,_simgym:1,_ts:Date.now()},data||{}));}catch(_){}}
  function lsGet(k){try{return localStorage.getItem(k);}catch(_){return null;}}
  function lsSet(k,v){try{localStorage.setItem(k,v);}catch(_){return null;}}
  function ssGet(k){try{return sessionStorage.getItem(k);}catch(_){return null;}}
  function ssSet(k,v){try{sessionStorage.setItem(k,v);}catch(_){return null;}}

  /* --- T61: bramka ceny Pro (wspolna z christina-wishlist-page.js) ------- */
  function ccEntitled(){
    return (typeof window.__CC_B2B !== 'undefined' && window.__CC_B2B === true);
  }
  function ccRestricted(p){
    var tags = (p && p.tags) || [];
    if (!tags.length) return false;
    return tags.some(function(t){ return /^(b2b|professional)$/i.test(String(t).trim()); });
  }
  function ccLocked(p){ return ccRestricted(p) && !ccEntitled(); }
  function ccLockedText(){
    var l = (document.documentElement.getAttribute('lang') || 'pl').toLowerCase();
    if (l.indexOf('zh') === 0) return '驗證後顯示價格';
    if (l.indexOf('en') === 0) return 'Price after verification';
    return 'Cena po weryfikacji';
  }

  var CARD_SELECTOR = '.product-card.product-card--card, .card-product:not([class*="__"])';
  var EXCLUDED_BRAND_RE = /\b(wish(?!list)|silk(?!en)|chateau|vino(?!therapy))\b/i;

  /* T71 (2026-08-26): „Dostawa 24-48h" obiecywala DORECZENIE sprzeczne z
     /pages/dostawa-i-platnosc („1-3 dni robocze"). Teraz mowa o nadaniu, zgodnie
     z cut-offem 12:00 z mechanizmu ship-countdown (T55). */
  var TRUST_BLOCK_I18N = {
    pl:{r:'Sygnaly zaufania',a1:'Wysyłka w 24 h (do 12:00)',a2:'InPost / Kurier · ponad 200 zł GRATIS',b1:'30 dni na zwrot',b2:'Łatwe odesłanie, pełna gwarancja',c1:'Oryginalny dystrybutor',c2:'TOP Cosmetics Europe — wyłączny CEE',d1:'BLIK · karta · PayPal',d2:'Bezpieczne płatności SSL'},
    en:{r:'Trust signals',a1:'Ships in 24 h (order by 12:00)',a2:'InPost / Courier · over 200 PLN FREE',b1:'30-day returns',b2:'Easy return, full guarantee',c1:'Authorised distributor',c2:'TOP Cosmetics Europe — exclusive CEE',d1:'BLIK · card · PayPal',d2:'Secure SSL payments'},
    zh:{r:'信任標誌',a1:'24 小時內出貨（12:00 前下單）',a2:'InPost / 快遞 · 滿 200 PLN 免運',b1:'30 天退貨',b2:'退貨簡便，完整保障',c1:'官方授權經銷商',c2:'TOP Cosmetics Europe — 中東歐獨家',d1:'BLIK · 信用卡 · PayPal',d2:'SSL 安全付款'}
  };
  var TRUST_BLOCK_SVG = ['<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 7l9-4 9 4v6c0 5-4 9-9 11-5-2-9-6-9-11V7z"/><path d="M9 12l2 2 4-4"/></svg>','<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 8l-9 4-9-4"/><path d="M21 8v8c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V8"/><path d="M3 8l9-4 9 4"/></svg>','<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2L4 7v6c0 5 4 8 8 9 4-1 8-4 8-9V7l-8-5z"/><path d="M9 12l2 2 4-4"/></svg>','<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="6" width="20" height="12" rx="2"/><path d="M2 10h20"/></svg>'];
  function trustBlockHTML(){
    var lang = (document.documentElement.getAttribute('lang')||'pl').toLowerCase().slice(0,2);
    var t = TRUST_BLOCK_I18N[lang] || TRUST_BLOCK_I18N.pl;
    function item(i,strong,small){return '<div class="cb-trust-block__item"><span class="cb-trust-block__icon" aria-hidden="true">'+TRUST_BLOCK_SVG[i]+'</span><div class="cb-trust-block__txt"><strong>'+strong+'</strong><span>'+small+'</span></div></div>';}
    return '<div class="cb-trust-block" role="region" aria-label="'+t.r+'">'+item(0,t.a1,t.a2)+item(1,t.b1,t.b2)+item(2,t.c1,t.c2)+item(3,t.d1,t.d2)+'</div>';
  }
  var TRUST_BLOCK_HTML = trustBlockHTML();

  function injectTrustBlock(){
    if(!/\/products\//.test(location.pathname))return;
    if(document.querySelector('.cb-trust-block'))return;
    var btn = document.querySelector('form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] [name="add"], product-form button.button--primary, .product-form button[type="submit"], [id*="ProductSubmitButton"], .product__form button[type="submit"]');
    if(!btn)return;
    var anchor = btn.closest('.product-form__buttons')||btn.closest('.product-form__cart')||btn;
    var div = document.createElement('div'); div.innerHTML = TRUST_BLOCK_HTML;
    anchor.parentNode.insertBefore(div.firstChild, anchor);
  }

  function extractVolumeMl(title){
    if(!title)return 0;
    var m = title.match(/(\d+(?:[.,]\d+)?)\s*(ml|g|gr|ml\.|g\.)\b/i);
    if(!m)return 0;
    var v = parseFloat(m[1].replace(',','.'));
    return isNaN(v)?0:v;
  }
  function fmtPLN(value){try{return value.toFixed(2).replace('.',',') + ' PLN';}catch(_){return value+' PLN';}}
  function parsePLN(text){
    if(!text)return 0;
    var m = text.replace(/\s/g,'').match(/(\d+(?:[.,]\d+)?)/);
    if(!m)return 0;
    return parseFloat(m[1].replace(',','.'));
  }
  function injectPricePerMl(){
    $$(CARD_SELECTOR).forEach(function(card){
      if(card.dataset.cbPpmDone)return;
      var titleEl = card.querySelector('.product-card__title, .card__title, .heading');
      var priceEl = card.querySelector('.price__regular .price-item--regular, .price .price-item--regular, .product-card__price .price-item');
      if(!titleEl||!priceEl)return;
      card.dataset.cbPpmDone = '1';
      var existing = card.textContent && card.textContent.match(/\(\s*\d+[\d ,.]*\s*PLN\s*\/\s*100\s*ml\s*\)/i);
      if(existing)return;
      var v = extractVolumeMl(titleEl.textContent||'');
      var p = parsePLN(priceEl.textContent||'');
      if(v<=0||p<=0)return;
      var u = (/g\b/i.test((titleEl.textContent.match(/\d+\s*(ml|g)/i)||[])[0]||'')?'g':'ml');
      var span = document.createElement('span'); span.className = 'cb-ppm'; span.textContent = fmtPLN(p/v)+' / '+u; span.setAttribute('title','Cena za 1 '+u);
      var priceWrap = priceEl.closest('.price')||priceEl.parentNode;
      if(priceWrap && !priceWrap.querySelector('.cb-ppm'))priceWrap.appendChild(span);
    });
  }

  var ORIG_FETCH = null;
  function hookCartFetch(){
    if(!window.fetch || window.__cbSimgymFetchHooked)return;
    window.__cbSimgymFetchHooked = true;
    ORIG_FETCH = window.fetch.bind(window);
    window.fetch = function(input, init){
      var url = typeof input==='string'?input:(input&&input.url)||'';
      var p = ORIG_FETCH(input, init);
      if(/\/cart\/add(\.js)?(\?|$)/.test(url)){
        p.then(function(res){
          /* T-MOD7 (2026-10-31): 422 (brak stanu, pro-guard) to nie jest dodanie: bez toastu i bez zdarzen. */
          if(res && res.ok && res.clone){
            res.clone().json().then(function(data){
              try{
                var items = data.items||(data.id?[data]:[]);
                items.forEach(function(it){
                  var isGift = (it.price===0 || /gift|prezent|sample|próbka|gratis/i.test((it.title||'')+' '+(it.product_title||'')));
                  fireDL('cca_quick_add',{product_id:it.product_id, variant_id:it.id||it.variant_id, item_id:String(it.product_id||''), item_name:it.product_title||it.title, item_brand:'Christina', item_category:it.product_type||'', title:it.product_title||it.title, quantity:it.quantity, price:(it.price||0)/100, currency:'PLN', is_gift:isGift, segment:bodySegment(), source:getCurrentSource(), _v:'v2'});
                  if(isGift)fireDL('gift_added',{title:it.product_title||it.title, variant_id:it.id||it.variant_id});
                });
                var anyGift = items.some(function(it){return it.price===0;});
                showToast(items[0], anyGift);
                suppressCartDrawerOpen();
              }catch(_){}
            }).catch(function(){});
          }
        });
      }
      return p;
    };
  }

  function getCurrentSource(){
    if(/\/products\//.test(location.pathname))return 'pdp';
    if(/\/collections\//.test(location.pathname))return 'collection';
    if(/\/search/.test(location.pathname))return 'search';
    if(location.pathname==='/'||location.pathname==='')return 'home';
    return 'other';
  }

  var toastTimer = null;
  function showToast(item, isGift){
    var existing = document.querySelector('.cb-toast');
    if(existing && existing.parentNode)existing.parentNode.removeChild(existing);
    var name = (item && (item.product_title||item.title))||'Produkt';
    var icon = isGift?'🎁':'✓';
    var heading = isGift?'Dodano prezent':'Dodano do koszyka';
    var t = document.createElement('div'); t.className = 'cb-toast'+(isGift?' cb-toast--gift':''); t.setAttribute('role','status'); t.setAttribute('aria-live','polite');
    /* T74 (2026-08-26): opacity .85 na NAZWIE PRODUKTU w toascie „Dodano do koszyka"
       — opacity na tekscie tresciowym, wbrew T58 §3. Wygaszanie kolorem o zmierzonym
       kontrascie zamiast przezroczystoscia.
       UWAGA na kolor: `.cb-toast` ma `background:#000` (assets/christina-simgym.css),
       wiec kanoniczne `#5f6064` z T58 dalo by tu 3,34:1 — PONIZEJ AA. Na ciemnym tle
       wygaszamy w druga strone: `#e6e1d5` (hairline z palety Christina) = 16,1:1
       na czerni, przy bieli naglowka 21:1 — roznica tonu zostaje, kontrast rosnie.
       Nie podmieniac na #5f6064 bez zmiany tla toastu. */
    t.innerHTML = '<span class="cb-toast__icon" aria-hidden="true">'+icon+'</span><div><strong>'+heading+'</strong><br><span style="color:#e6e1d5">'+(name||'').replace(/[<>]/g,'')+(isGift?' · 0 PLN':'')+'</span><br><a href="/cart">Pokaż koszyk →</a></div>';
    document.body.appendChild(t);
    requestAnimationFrame(function(){t.classList.add('cb-toast--show');});
    if(toastTimer)clearTimeout(toastTimer);
    toastTimer = setTimeout(function(){t.classList.remove('cb-toast--show'); setTimeout(function(){if(t.parentNode)t.parentNode.removeChild(t);},250);},3800);
    fireDL('cart_toast_shown',{title:name, is_gift:!!isGift});
  }

  function suppressCartDrawerOpen(){
    var src = getCurrentSource();
    if(src==='pdp')return;
    try{
      setTimeout(function(){
        var drawers = $$('.cart-drawer, [class*="cart-drawer"], [class*="drawer--cart"], [is*="cart-drawer"]');
        drawers.forEach(function(d){
          if(d.classList.contains('is-open')||d.classList.contains('drawer--open')||d.classList.contains('cart-drawer--open')||d.hasAttribute('open')){
            try{d.classList.remove('is-open','drawer--open','cart-drawer--open');d.removeAttribute('open');}catch(_){}
            try{document.dispatchEvent(new CustomEvent('drawer:close',{detail:{drawer:d}}));}catch(_){}
            $$('.drawer-overlay, [class*="drawer-overlay"], [class*="overlay"][class*="drawer"]').forEach(function(o){try{o.classList.remove('is-open','drawer-overlay--open');}catch(_){}});
            document.body.classList.remove('drawer-open','no-scroll','overflow-hidden');
            fireDL('cart_drawer_suppressed',{source:src});
          }
        });
      },50);
    }catch(_){}
  }

  function rememberCollectionContext(){
    if(!/\/collections\//.test(location.pathname))return;
    var url = location.pathname + (location.search||'');
    var coll = (location.pathname.match(/\/collections\/([^/]+)/)||[])[1];
    var title = (document.querySelector('h1')||{}).textContent || coll;
    ssSet('cb_last_collection', JSON.stringify({url:url, handle:coll, title:(title||'').trim().slice(0,80), ts:Date.now()}));
  }
  function injectBackToResults(){
    if(!/\/products\//.test(location.pathname))return;
    if(document.querySelector('.cb-back-results'))return;
    var raw = ssGet('cb_last_collection'); if(!raw)return;
    var ctx = null; try{ctx = JSON.parse(raw);}catch(_){return;}
    if(!ctx || !ctx.url)return;
    if(ctx.ts && (Date.now()-ctx.ts > 24*60*60*1000))return;
    var a = document.createElement('a'); a.className = 'cb-back-results'; a.href = ctx.url;
    a.innerHTML = '<span class="cb-back-results__arrow">←</span> Wróć do: '+(ctx.title||'wyników').replace(/[<>]/g,'');
    on(a,'click',function(){fireDL('cca_back_to_results',{from:'pdp',to:ctx.url});});
    var anchor = document.querySelector('.product__info, .product-info, .product__details, main .product');
    if(anchor)anchor.insertBefore(a, anchor.firstChild);
  }

  function injectViewAllLink(){
    if(!/\/products\//.test(location.pathname))return;
    if(document.querySelector('.cb-view-all'))return;
    var coll = null;
    var raw = ssGet('cb_last_collection');
    if(raw){try{var ctx = JSON.parse(raw); if(ctx && ctx.handle)coll = {handle:ctx.handle,title:ctx.title};}catch(_){}}
    if(!coll){
      var bodyClass = document.body.className||'';
      var lineMatch = bodyClass.match(/christina-line-([a-z0-9-]+)/);
      if(lineMatch){coll = {handle: lineMatch[1] === 'muse-red' ? 'muse-red-line' : lineMatch[1], title: 'wszystkie produkty linii '+lineMatch[1].replace(/-/g,' ')};}
    }
    if(!coll)return;
    var anchor = document.querySelector('.product-form__buttons, .product__form, .product-form');
    if(!anchor)return;
    var a = document.createElement('a'); a.className = 'cb-view-all'; a.href = '/collections/'+coll.handle;
    a.textContent = 'Zobacz wszystkie '+(coll.title||'produkty')+' →';
    on(a,'click',function(){fireDL('cca_view_all_category',{from:'pdp',collection:coll.handle});});
    anchor.parentNode.insertBefore(a, anchor.nextSibling);
  }

  var ADVISOR_DISMISS_KEY = 'cb_advisor_dismissed_at';
  function isAdvisorRecentlyDismissed(){
    var t = parseInt(lsGet(ADVISOR_DISMISS_KEY)||'0',10);
    if(!t)return false;
    return (Date.now()-t) < 2*3600*1000;
  }
  function markAdvisorDismissed(){lsSet(ADVISOR_DISMISS_KEY,String(Date.now())); fireDL('cca_popup_close',{type:'advisor'});}
  function bindAdvisorDismissTracking(){
    document.addEventListener('click',function(e){
      var t = e.target; if(!t || !t.closest)return;
      var btn = t.closest('[data-cca-close], .cca-close, .cca-advisor__close, [aria-label*="zamknij" i], [aria-label*="close" i]');
      if(btn && btn.closest('.cca-advisor, [id*="advisor"], [class*="cca-"]'))markAdvisorDismissed();
    },true);
  }
  function applyAdvisorSuppress(){if(isAdvisorRecentlyDismissed()){document.body.setAttribute('data-cca-suppress','1'); fireDL('cca_suppressed',{reason:'recently_dismissed'});}}
  function setupAdvisorDwell(){
    if(isAdvisorRecentlyDismissed())return;
    setTimeout(function(){document.body.setAttribute('data-cca-dwell-ready','1'); fireDL('cca_dwell_ready',{dwell_ms:8000});},8000);
    on(document,'mouseout',function(e){if(e.clientY<=0 && !document.body.hasAttribute('data-cca-exit-ready')){document.body.setAttribute('data-cca-exit-ready','1'); fireDL('cca_exit_intent',{});}});
  }

  function trackFiltersAndZeroResults(){
    var lastSearch = location.search;
    /* T-MOD6 (2026-10-31): filtry istnieja tylko na kolekcjach i wyszukiwarce; poza nimi bez staleego odpytywania. */
    if(/\/(collections|search)/.test(location.pathname)) setInterval(function(){if(location.search !== lastSearch){lastSearch = location.search; if(/[?&]filter[._-]/.test(lastSearch)||/[?&]q=/.test(lastSearch))fireDL('cca_filter_apply',{search:lastSearch.slice(0,200)});}}, 2500);
    setTimeout(function(){
      var noResults = document.querySelector('.collection-empty, .no-results, [class*="no-result"], [class*="empty-collection"], [class*="empty-state"]');
      if(noResults && /\/(collections|search)/.test(location.pathname))fireDL('cca_zero_results',{path:location.pathname,search:location.search.slice(0,200)});
    },1200);
  }
  function watchAjaxErrors(){on(window,'unhandledrejection',function(e){fireDL('cca_js_error',{message:((e&&e.reason&&(e.reason.message||e.reason.toString()))||'').slice(0,200),path:location.pathname});});}

  function hideExcludedBrandsMenu(){
    $$('header a, nav a, [class*="menu"] a').forEach(function(a){
      var txt = (a.textContent||'').trim();
      var href = (a.getAttribute('href')||'');
      if(EXCLUDED_BRAND_RE.test(txt) || EXCLUDED_BRAND_RE.test(href)){
        if(/wishlist|silken|vinotherapy|aktualnosci|article/i.test(txt+href))return;
        var li = a.closest('li');
        if(li){li.classList.add('cb-menu-hidden'); li.style.display='none';}
        else{a.classList.add('cb-menu-hidden'); a.style.display='none';}
      }
    });
  }

  function bodySegment(){return (window.__cca_customer && window.__cca_customer.segment) || lsGet('cb_segment_view') || 'home';}
  function applySegmentView(){
    var seg = lsGet('cb_segment_view') || 'home';
    document.body.setAttribute('data-segment-view', seg);
    fireDL('home_pro_view_apply',{segment:seg});
  }
  function injectSegmentToggle(){
    if(document.querySelector('.cb-segment-toggle'))return;
    var current = lsGet('cb_segment_view') || 'home';
    var wrap = document.createElement('div'); wrap.className='cb-segment-toggle'; wrap.setAttribute('role','group'); wrap.setAttribute('aria-label','Wybór segmentu');
    wrap.innerHTML = '<button class="cb-segment-toggle__btn cb-segment-toggle__btn--home '+(current==='home'?'cb-segment-toggle__btn--active':'')+'" data-seg="home">Pielęgnacja domowa</button><button class="cb-segment-toggle__btn cb-segment-toggle__btn--pro '+(current==='pro'?'cb-segment-toggle__btn--active':'')+'" data-seg="pro">Dla kosmetologów</button>';
    document.body.appendChild(wrap);
    $$('.cb-segment-toggle__btn', wrap).forEach(function(b){
      on(b,'click',function(){
        var seg = b.getAttribute('data-seg'); lsSet('cb_segment_view', seg);
        $$('.cb-segment-toggle__btn').forEach(function(x){x.classList.remove('cb-segment-toggle__btn--active');});
        b.classList.add('cb-segment-toggle__btn--active');
        applySegmentView(); fireDL('home_pro_toggle',{to:seg});
        applyCardSegmentBadges();
      });
    });
  }

  /* v2.3 CRITICAL FIX: inject .cb-badges DIRECTLY na card root, NIE do .product-card__media (flickity territory) */
  function applyCardSegmentBadges(){
    $$(CARD_SELECTOR).forEach(function(card){
      if(card.dataset.cbBadgesDone)return;
      card.dataset.cbBadgesDone = '1';
      var href = (card.querySelector('a[href*="/products/"]')||{}).href || '';
      var title = (card.querySelector('.product-card__title, .card__title, .heading, h3, h4')||{}).textContent || '';
      var fullText = (card.textContent||'').toLowerCase();
      var isPro = /\bpro\b|profesjonalny|professional|proffesional|salon|gabinet/i.test(fullText) || /proffesional|professional/.test(href);
      /* T-VF3-BADGE (2026-10-31) ZESTAW TYLKO NA ZESTAWACH: regex szedl po calym tekscie karty, wiec lapal "kit" i "protok" w dowolnym miejscu. Teraz cale slowo w tytule produktu. */
      var hasBundle = /(^|[^a-z\u0105\u0107\u0119\u0142\u0144\u00f3\u015b\u017a\u017c])(zestaw[a-z\u0105\u0119\u00f3]*|kit|bundle)(?![a-z\u0105\u0107\u0119\u0142\u0144\u00f3\u015b\u017a\u017c])/i.test(title);
      var spfMatch = title.match(/SPF\s*(\d+)/i);
      card.setAttribute('data-segment', isPro?'pro':'home');
      // Build badges
      var html = '';
      if(isPro)html += '<span class="cb-badge cb-badge--pro" title="Produkt profesjonalny">PRO</span>';
      if(hasBundle)html += '<span class="cb-badge cb-badge--kit" title="Treatment Kit / Zestaw">ZESTAW</span>';
      if(spfMatch)html += '<span class="cb-badge cb-badge--spf" title="Ochrona przeciwsłoneczna">SPF '+spfMatch[1]+'</span>';
      if(!html)return;
      // Wstaw badges DIRECTLY na card root (NIE do .product-card__media)
      // CSS: .cb-badges{position:absolute;top:8px;left:8px} → card root ma już position:relative natywnie
      var badgesEl = document.createElement('div');
      badgesEl.className = 'cb-badges';
      badgesEl.innerHTML = html;
      // Insert na koniec card root — nie modyfikuje media wrap
      card.appendChild(badgesEl);
    });
  }

  var QV_MODAL_HTML = '<div class="cb-qv-backdrop" data-open="0" role="dialog" aria-modal="true" aria-label="Szybki podgląd produktu"><div class="cb-qv-modal" tabindex="-1"><button class="cb-qv-modal__close" aria-label="Zamknij">✕</button><div class="cb-qv-modal__img"><div class="cb-qv-modal__loading">Wczytywanie…</div></div><div class="cb-qv-modal__body"><div class="cb-qv-modal__eyebrow"></div><h2 class="cb-qv-modal__title"></h2><div class="cb-qv-modal__badges"></div><div class="cb-qv-modal__price"></div><div class="cb-qv-modal__ppm"></div><div class="cb-qv-modal__desc"></div><div class="cb-qv-modal__actions"><button class="cb-qv-modal__atc" data-action="atc">Dodaj do koszyka</button><a class="cb-qv-modal__link" href="/collections/all" data-action="full">Zobacz pełną stronę produktu →</a></div></div></div></div>';
  function ensureQvModal(){
    if(document.querySelector('.cb-qv-backdrop'))return;
    var wrap = document.createElement('div'); wrap.innerHTML = QV_MODAL_HTML;
    document.body.appendChild(wrap.firstChild);
    var backdrop = document.querySelector('.cb-qv-backdrop');
    on(backdrop,'click',function(e){if(e.target===backdrop)closeQv();});
    on(backdrop.querySelector('.cb-qv-modal__close'),'click',closeQv);
    on(document,'keydown',function(e){if(e.key==='Escape' && backdrop.getAttribute('data-open')==='1')closeQv();});
  }
  function openQv(handle){
    if(!handle)return;
    ensureQvModal();
    var backdrop = document.querySelector('.cb-qv-backdrop');
    var modal = backdrop.querySelector('.cb-qv-modal');
    backdrop.setAttribute('data-open','1');
    document.body.style.overflow='hidden';
    modal.querySelector('.cb-qv-modal__img').innerHTML = '<div class="cb-qv-modal__loading">Wczytywanie…</div>';
    ['.cb-qv-modal__title','.cb-qv-modal__price','.cb-qv-modal__ppm','.cb-qv-modal__desc','.cb-qv-modal__eyebrow'].forEach(function(s){modal.querySelector(s).textContent='';});
    modal.querySelector('.cb-qv-modal__badges').innerHTML='';
    modal.querySelector('.cb-qv-modal__atc').setAttribute('disabled','true');
    setTimeout(function(){modal.focus();},50);
    var origFetch = ORIG_FETCH || window.fetch.bind(window);
    origFetch('/products/'+handle+'.js').then(function(r){return r.json();}).then(function(p){
      renderQv(p);
      /* T61 — `price` tylko dla produktow, ktorych cene wolno pokazac */
      var dl = {item_id:String(p.id||''), item_name:p.title, item_brand:'Christina', item_category:p.product_type||'', currency:'PLN', handle:p.handle};
      if(!ccLocked(p)) dl.price = (p.price||0)/100;
      fireDL('quick_view_open', dl);
    }).catch(function(err){
      modal.querySelector('.cb-qv-modal__img').innerHTML = '<div class="cb-qv-modal__loading">Błąd. <br><a href="/products/'+handle+'" style="color:#535458">Otwórz pełną stronę →</a></div>';
      fireDL('quick_view_error',{handle:handle,error:String(err).slice(0,100)});
    });
  }
  function closeQv(){var b = document.querySelector('.cb-qv-backdrop'); if(!b)return; b.setAttribute('data-open','0'); document.body.style.overflow=''; fireDL('quick_view_close',{});}
  function renderQv(p){
    var modal = document.querySelector('.cb-qv-backdrop .cb-qv-modal');
    var locked = ccLocked(p);
    var img = (p.featured_image||(p.images&&p.images[0])||'');
    var imgUrl = img ? (img.startsWith('//')?'https:'+img:img) : '';
    modal.querySelector('.cb-qv-modal__img').innerHTML = imgUrl?'<img src="'+imgUrl+'" alt="'+(p.title||'').replace(/"/g,'')+'">':'';
    modal.querySelector('.cb-qv-modal__title').textContent = p.title||'';
    modal.querySelector('.cb-qv-modal__eyebrow').textContent = (p.vendor||p.product_type||'').toUpperCase();
    var price = (p.price||0)/100;
    if(locked){
      /* T61 — zadna kwota nie trafia do DOM */
      modal.querySelector('.cb-qv-modal__price').textContent = ccLockedText();
      modal.querySelector('.cb-qv-modal__ppm').textContent = '';
    } else {
      var cmp = p.compare_at_price?(p.compare_at_price/100):0;
      var priceHtml = fmtPLN(price);
      if(cmp>price)priceHtml += '<span class="cb-qv-modal__compare">'+fmtPLN(cmp)+'</span>';
      modal.querySelector('.cb-qv-modal__price').innerHTML = priceHtml;
      var v = extractVolumeMl(p.title||'');
      if(v>0){var u = (/g\b/i.test((p.title.match(/\d+\s*(ml|g)/i)||[])[0]||'')?'g':'ml'); modal.querySelector('.cb-qv-modal__ppm').textContent = fmtPLN(price/v)+' / '+u;}
    }
    var desc = (p.description||'').replace(/<[^>]+>/g,'').slice(0,500);
    modal.querySelector('.cb-qv-modal__desc').textContent = desc;
    var bdg = modal.querySelector('.cb-qv-modal__badges'); bdg.innerHTML = '';
    var spfMatch = (p.title||'').match(/SPF\s*(\d+)/i);
    if(spfMatch)bdg.innerHTML += '<span class="cb-badge cb-badge--spf">SPF '+spfMatch[1]+'</span>';
    var tags = (p.tags||[]).map(function(t){return String(t).toLowerCase();});
    if(tags.some(function(t){return /professional|proffesional|\bpro\b|salon/.test(t);}))bdg.innerHTML += '<span class="cb-badge cb-badge--pro">PRO</span>';
    else bdg.innerHTML += '<span class="cb-badge cb-badge--home">HOME CARE</span>';
    if(tags.some(function(t){return /vegan/.test(t);}))bdg.innerHTML += '<span class="cb-badge cb-badge--vegan">VEGAN</span>';
    if(tags.some(function(t){return /bestseller/.test(t);}))bdg.innerHTML += '<span class="cb-badge cb-badge--bestseller">BESTSELLER</span>';
    var atcBtn = modal.querySelector('.cb-qv-modal__atc');
    if(locked){
      /* T61 — brak sciezki do koszyka bez uprawnienia B2B */
      atcBtn.setAttribute('disabled','true');
      atcBtn.setAttribute('hidden','hidden');
      atcBtn.style.display = 'none';
      atcBtn.onclick = null;
      modal.querySelector('.cb-qv-modal__link').setAttribute('href','/products/'+p.handle);
      return;
    }
    atcBtn.removeAttribute('hidden');
    atcBtn.style.display = '';
    atcBtn.removeAttribute('disabled');
    var variantId = (p.variants && p.variants[0] && p.variants[0].id) || p.id;
    var available = p.available !== false;
    if(!available){atcBtn.textContent = 'Niedostępny'; atcBtn.setAttribute('disabled','true');}
    atcBtn.onclick = function(){
      if(!available)return;
      var origFetch = ORIG_FETCH || window.fetch.bind(window);
      atcBtn.setAttribute('disabled','true'); atcBtn.textContent = 'Dodawanie…';
      origFetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:variantId,quantity:1}]})}).then(function(r){return r.json();}).then(function(){
        var dlAdd = {item_id:String(p.id||''), item_name:p.title, item_brand:'Christina', item_category:p.product_type||'', currency:'PLN', quantity:1, handle:p.handle};
        if(!ccLocked(p)) dlAdd.price = (p.price||0)/100;
        fireDL('quick_view_add_to_cart', dlAdd);
        closeQv();
        var cartCount = document.querySelector('[class*="cart-count"], .header__cart-count, .cart-link__count');
        if(cartCount){var n = parseInt(cartCount.textContent||'0',10); cartCount.textContent = (n+1);}
      }).catch(function(){atcBtn.removeAttribute('disabled'); atcBtn.textContent = 'Spróbuj ponownie';});
    };
    modal.querySelector('.cb-qv-modal__link').setAttribute('href','/products/'+p.handle);
  }

  /* v2.3 CRITICAL FIX: quick-view trigger via DELEGATION (click-to-quickview), nie injection DOM */
  function bindQuickViewDelegated(){
    if(window.__cbQvDelegated)return;
    window.__cbQvDelegated = true;
    // Long-press (mobile) or Alt+click (desktop) opens quick-view instead of nav
    on(document, 'click', function(e){
      if(!e.altKey)return;
      var link = e.target.closest && e.target.closest('a[href*="/products/"]');
      if(!link)return;
      var card = link.closest && link.closest('.product-card.product-card--card, .card-product');
      if(!card)return;
      var handle = (link.getAttribute('href').match(/\/products\/([^/?#]+)/)||[])[1];
      if(!handle)return;
      e.preventDefault();
      e.stopPropagation();
      openQv(handle);
      fireDL('quick_view_click',{handle:handle, source:getCurrentSource(), trigger:'alt-click'});
    }, true);
  }

  function enhancePagination(){
    if(!/\/(collections|search)/.test(location.pathname))return;
    $$('button, a').forEach(function(el){
      if(el.dataset.cbPagHooked)return;
      var txt = (el.textContent||'').trim().toLowerCase();
      if(!/pokaż\s*więcej|załaduj\s*więcej|load\s*more|next\s*page/.test(txt))return;
      el.dataset.cbPagHooked = '1';
      on(el,'click',function(){
        var nextPage = (parseInt((new URLSearchParams(location.search).get('page')||'1'),10)) + 1;
        try{var newUrl = new URL(location.href); newUrl.searchParams.set('page', nextPage); history.replaceState({page:nextPage}, '', newUrl.toString());}catch(_){}
        fireDL('pagination_next',{page:nextPage, path:location.pathname, search:location.search.slice(0,200)});
        fireDL('infinite_scroll_load',{page:nextPage});
      });
    });
  }

  function injectTreatmentKitLink(){
    var path = location.pathname;
    var isProColl = /\/collections\/.*(professional|proffesional|pro\b)/i.test(path);
    if(!isProColl)return;
    if(document.querySelector('.cb-kit-link'))return;
    var h1 = document.querySelector('h1'); if(!h1)return;
    var a = document.createElement('a'); a.className = 'cb-kit-link'; a.href = '/collections/zestawy-zabiegowe';
    a.textContent = 'Zobacz zestawy zabiegowe i protokoły gabinetowe';
    on(a,'click',function(){fireDL('treatment_kit_view',{source:path});});
    h1.parentNode.insertBefore(a, h1.nextSibling);
  }

  function boot(){
    try{rememberCollectionContext();}catch(_){}
    try{injectTrustBlock();}catch(_){}
    try{injectPricePerMl();}catch(_){}
    try{injectBackToResults();}catch(_){}
    try{injectViewAllLink();}catch(_){}
    try{hookCartFetch();}catch(_){}
    try{bindAdvisorDismissTracking();}catch(_){}
    try{applyAdvisorSuppress();}catch(_){}
    try{setupAdvisorDwell();}catch(_){}
    try{trackFiltersAndZeroResults();}catch(_){}
    try{watchAjaxErrors();}catch(_){}
    try{hideExcludedBrandsMenu();}catch(_){}
    try{applySegmentView();}catch(_){}
    try{injectSegmentToggle();}catch(_){}
    try{applyCardSegmentBadges();}catch(_){}
    /* R6-PERF/SEO: ensureQvModal() wywolywane leniwie w openQv() — modal nie
       istnieje w DOM przy wejsciu, wiec nie psuje audytu crawlable-anchors. */
    try{bindQuickViewDelegated();}catch(_){}
    try{enhancePagination();}catch(_){}
    try{injectTreatmentKitLink();}catch(_){}
  }

  function __cbIdle(fn){
    var r = window.requestIdleCallback || function(f){ return setTimeout(f, 1); };
    try { r(fn, { timeout: 2500 }); } catch(_) { setTimeout(fn, 1); }
  }
  function __cbStart(){ __cbIdle(boot); }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded', __cbStart);
  else __cbStart();

  /* R6-PERF: boot przeniesiony na requestIdleCallback (nie blokuje pierwszego renderu).
     Dwa przebiegi kontrolne (1500 ms i 4000 ms) scalone w JEDEN na idle @4000 ms —
     kazdy z nich skanowal m.in. 'header a, nav a, [class*="menu"] a' (mega menu),
     czyli setki wezlow, trzy razy na wejscie. */
  setTimeout(function(){
    __cbIdle(function(){
      try{applyCardSegmentBadges();}catch(_){}
      try{injectPricePerMl();}catch(_){}
      try{enhancePagination();}catch(_){}
      try{hideExcludedBrandsMenu();}catch(_){}
    });
  }, 4000);

  window.__cbSimgym = {
    rerun: boot, showToast: showToast, fireDL: fireDL,
    dismissAdvisor: markAdvisorDismissed, openQv: openQv, closeQv: closeQv,
    setSegment: function(s){lsSet('cb_segment_view',s); applySegmentView();},
    hideBrands: hideExcludedBrandsMenu,
    version: '2026-08-26-T74'
  };
})();
